import { connect } from 'react-redux'

import type { TypedDispatch } from '../../..'
import { saveTowingFormState } from '../../../actions/api'
import type { AppState } from '../../../types'
import type { TowingFormReduxState } from '../../../types/States'
import TowingConfirmButton from './TowingConfirmButton'

interface TowingConfirmToNextProps {
  enabled: boolean
  saving: boolean
  towingFormState: TowingFormReduxState
  onActionChange: (towingFormState: TowingFormReduxState, stepKey: string) => void
}

const TowingConfirmToNext = ({
  enabled,
  onActionChange,
  saving,
  towingFormState,
}: TowingConfirmToNextProps) => {
  const handleHandOverToNext = () => {
    onActionChange(towingFormState, 'TRANSITION_TO_NEXT')
  }

  return (
    <TowingConfirmButton
      onClick={(e) => {
        e.stopPropagation()
        handleHandOverToNext()
      }}
      disabled={!enabled}
      buttonText={saving ? 'Tallennetaan' : 'Kuittaa valmis seuraavalle'}
      confirmed={false}
    />
  )
}

const mapStateToProps = (state: AppState) => {
  const saving = state.towingFormState.savingStep === 'TRANSITION_TO_NEXT'
  const towingFormState = state.towingFormState
  return {
    saving,
    towingFormState,
  }
}

const mapDispatchToProps = (dispatch: TypedDispatch) => ({
  onActionChange: (towingFormState: TowingFormReduxState, stepKey: string) =>
    dispatch(saveTowingFormState(towingFormState, 'handover', stepKey)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TowingConfirmToNext)
